export default __webpack_public_path__ + "static/media/23.f16073bd.png";